var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es457.js.map
